import { render, staticRenderFns } from "./cardObject.vue?vue&type=template&id=58fc0de6&scoped=true"
import script from "./cardObject.vue?vue&type=script&lang=js"
export * from "./cardObject.vue?vue&type=script&lang=js"
import style0 from "./cardObject.vue?vue&type=style&index=0&id=58fc0de6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc0de6",
  null
  
)

export default component.exports